<template>
    <div class="wabident-option-field">
        <div class="row form-group" v-for="(value, key) in object" :key="key">
            <div class="col-md 4">
                {{ key }}
            </div>
            <div class="col-md-4">
                {{ value }}
            </div>
            <div class="col-md-4">
                <button @click="onDelete(key)" class="btn-wabident-round">Borrar <i class="fas fa-trash"></i></button>
            </div>
        </div>

        <div class="row form-group">
            <div class="col-md-4">
                <input v-model="tmp_key" type="text" class="form-control wabident-xsmall" :id="slug + '_key'">
                <label :for="slug" :id="slug + '_key'" class="wabident-info">Clave</label>
            </div>
            <div class="col-md-4">
                <input v-model="tmp_value" type="text" class="form-control wabident-xsmall" :id="slug + '_value'">
                <label :for="slug" :id="slug + '_value'" class="wabident-info">Valor</label>
            </div>
            <div class="col-md-4">
                <button @click="onAdd" class="btn-wabident-round">Añadir <i class="fas fa-plus"></i></button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['object', 'slug'],
    data() {
        return {
            tmp_key: '',
            tmp_value: '',
        };
    },
    methods: {
        onDelete(key) {
            this.$emit('delete', key);
        },
        onAdd() {
            this.$emit('add', this.tmp_key, this.tmp_value);
            this.tmp_key = '';
            this.tmp_value = '';
        }
    }
}
</script>

<style lang="scss">
.wabident-option-field {}
</style>